import { render, staticRenderFns } from "./crearResidente.vue?vue&type=template&id=04665006&scoped=true"
import script from "./crearResidente.vue?vue&type=script&lang=js"
export * from "./crearResidente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04665006",
  null
  
)

export default component.exports